import { useEffect, useRef, useState } from 'react'
import { XS, SM, MD, LG, XL } from './constants'
interface InitialValue {
  width: number
  height: number
}
const useBreakpoint = () => {
  const [breakpoint, setBreakPoint] = useState<number>()
  const [breakpointRange, setBreakPointRange] = useState('')
  const [windowSize, setWindowSize] = useState<InitialValue>({
    width: 0,
    height: 0,
  })

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()

    if (0 < windowSize.width && windowSize.width <= XS) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('xs')
    }
    if (XS < windowSize.width && windowSize.width <= SM) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('sm')
    }
    if (SM < windowSize.width && windowSize.width <= MD) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('md')
    }
    if (MD < windowSize.width && windowSize.width <= LG) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('lg')
    }
    if (LG < windowSize.width && windowSize.width <= XL) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('xl')
    }
    if (windowSize.width >= XL) {
      setBreakPoint(windowSize.width)
      setBreakPointRange('xxl')
    }

    return () => window.removeEventListener('resize', handleResize)
  }, [windowSize.width])
  return { breakpoint, breakpointRange }
}

const useDebouncedCallback = (callback: (...args: any[]) => void, delay = 300) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  return (...args: any[]) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }
}

export { useBreakpoint, useDebouncedCallback }
